import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { RootState } from 'store';
import { hideLoading } from 'reducer/rootReducer';

const LoadingSpinner = () => {
    const dispatch = useDispatch();
    const { loading } = useSelector((state: RootState) => state.common);

    React.useEffect(() => {
        if (loading) {
            setTimeout(() => {
                dispatch(hideLoading());
            }, 5000);
        }
    }, [loading, dispatch]);

    return (
        <>
            {loading && (
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        zIndex: 99999,
                        backgroundColor: 'rgba(0,0,0,0.5)',
                    }}>
                    <Box
                        sx={{
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}>
                        <CircularProgress />
                    </Box>
                </Box>
            )}
        </>
    );
};

export default LoadingSpinner;
